export const OrderInitialFilterElements = [
  {
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "senderHub",
    label: "هاب مبدا",
    WrapperClassName: "!filterInput",
    options: "hubOptions",
  },

  {
    isMain: true,
    isShow: false,
    type: "inputText2",
    valueName: "trackingNumber",
    label: "شماره سفارش",
    WrapperClassName: "!filterInput",
  },

  {
    isMain: true,
    isShow: false,
    type: "inputSelect",
    valueName: "receiverHub",
    label: "هاب مقصد",
    WrapperClassName: "!filterInput",
    options: "destinationHubOptions",
  },
]
